import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

export type AddAzugaDriverDialogSubmitEvent = {
  username: string;
  password: string;
  language: 'ES' | 'EN';
  truckId: string | null;
};

@Component({
  selector: 'app-add-azuga-driver-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './add-azuga-driver-dialog.html',
  styleUrl: './add-azuga-driver-dialog.css'
})
export class AddAzugaDriverDialog implements OnInit {
  private static readonly USERNAME_REGEX = /^(?=.{1,128}$)[A-Za-z0-9@^$.!`\-#+\'~]+$/;

  @Input() driverAlias: string = '';
  @Input() driverName: string = '';
  @Input() submitting: boolean = false;

  @Output() closed = new EventEmitter<void>();
  @Output() submit = new EventEmitter<AddAzugaDriverDialogSubmitEvent>();

  username: string = '';
  password: string = '';
  language: 'ES' | 'EN' = 'ES';
  truckId: string = '';
  error: string | null = null;
  showPassword: boolean = false;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.username = String(this.driverAlias || '').trim();
  }

  onCancel(): void {
    if (this.submitting) {
      return;
    }
    this.closed.emit();
  }

  onSubmit(): void {
    const username = String(this.username || '').trim();
    const password = String(this.password || '');
    const language = String(this.language || '').trim().toUpperCase();
    const truckId = String(this.truckId || '').trim();

    if (!username) {
      this.error = this.translate.instant('add_azuga_driver_dialog.username_required');
      return;
    }
    if (!AddAzugaDriverDialog.USERNAME_REGEX.test(username)) {
      this.error = this.translate.instant('add_azuga_driver_dialog.username_invalid');
      return;
    }
    if (password.trim().length < 6) {
      this.error = this.translate.instant('add_azuga_driver_dialog.password_invalid');
      return;
    }
    if (language !== 'ES' && language !== 'EN') {
      this.error = this.translate.instant('add_azuga_driver_dialog.language_required');
      return;
    }
    if (truckId.length > 0 && truckId.length < 3) {
      this.error = this.translate.instant('add_azuga_driver_dialog.truck_id_invalid');
      return;
    }

    this.error = null;
    this.submit.emit({
      username,
      password,
      language: language as 'ES' | 'EN',
      truckId: truckId.length > 0 ? truckId : null
    });
  }

  toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }
}
